import * as React from 'react';
import './ArSummaryMobile.scss';
import LocaleFormating from 'src/translation/localeFormating';
import ArSummaryModel from 'src/model/arSummary.model';
import ArSummaryCard from '../components/ArSummaryCard';

export interface IArSummaryProps {
  t: any;
  ArSummaryContent: ArSummaryModel;
  renderType: 'accountSetting' | 'other';
}

const ArSummaryMobile: React.SFC<IArSummaryProps> = props => {
  const {
    currentMonthBalance,
    openArBalance,
    firstMonthPastDueDate,
    secondMonthPastDueDate,
    thirdMonthPastDueDate
  } = props.ArSummaryContent;
  const { t } = props;

  const numberFormat = (value: number) => {
    return value
      ? LocaleFormating.formatCurrency(parseFloat(value.toString()))
      : LocaleFormating.formatCurrency(0.0);
  };

  const renderType = (type: string) => {
    if (type === 'accountSetting') {
      return (
        <React.Fragment>
          <div className="row">
            <div className="col-6">
              <p className="rp-ar-summary--header-detail">
                {t('accountInfoHeader.arBalance')}:
              </p>
            </div>
            <div className="col-6">
              <p className="rp-ar-summary--header-detail">
                {t('accountInfoHeader.currentBalance')}:
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <p className="rp-ar-summary--info-detail">
                {numberFormat(openArBalance)}
              </p>
            </div>
            <div className="col-6">
              <p className="rp-ar-summary--info-detail">
                {numberFormat(currentMonthBalance)}
              </p>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="rp-ar-summary-cards rp-ar-summary--header-container">
            <ArSummaryCard
              label={`${t('accountInfoHeader.arBalance')}:`}
              value={numberFormat(openArBalance)}
              past={false}
            />
          </div>
          <div className="rp-ar-summary-cards rp-ar-summary--header-container">
            <ArSummaryCard
              label={`${t('accountInfoHeader.currentBalance')}:`}
              value={numberFormat(currentMonthBalance)}
              past={false}
            />
          </div>
        </React.Fragment>
      );
    }
  };

  return (
    <div className="rp-arSummary">
      {renderType(props.renderType)}
      <div
        className={
          props.renderType === 'accountSetting'
            ? 'rp-ar-summary--header-container-no-margin'
            : 'rp-ar-summary-cards rp-ar-summary--header-container'
        }
      >
        <ArSummaryCard
          label={`${t('invoices.thirtyPastDueTxt')}:`}
          value={numberFormat(firstMonthPastDueDate)}
          past={true}
        />
      </div>
      <div
        className={
          props.renderType === 'accountSetting'
            ? 'rp-ar-summary--header-container-no-margin'
            : 'rp-ar-summary-cards rp-ar-summary--header-container'
        }
      >
        <ArSummaryCard
          label={`${t('invoices.sixtyPastDueTxt')}:`}
          value={numberFormat(secondMonthPastDueDate)}
          past={true}
        />
      </div>
      <div
        className={
          props.renderType === 'accountSetting'
            ? 'rp-ar-summary--header-container-no-margin'
            : 'rp-ar-summary-cards rp-ar-summary--header-container'
        }
      >
        <ArSummaryCard
          label={`${t('invoices.ninetyPastDueTxt')}:`}
          value={numberFormat(thirdMonthPastDueDate)}
          past={true}
        />
      </div>
    </div>
  );
};

export default ArSummaryMobile;
